import { dawaAutocomplete } from 'dawa-autocomplete2';
import $ from 'jquery';
import TileLayer from 'ol/layer/Tile';
import { register } from 'ol/proj/proj4';
import { TileWMS } from 'ol/source';
import proj4 from 'proj4';
import { password, username } from '../datafordeler';
import { getEnv } from '../environment';
import { topoSkaermKort } from '../layers';

/*global OLUtils, VDMap, VDMapTileGrid */

proj4.defs('EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
register(proj4);

let modalIsShown = false;

$(() => {
    dawaAutocomplete($('#addressField')[0], {
        select(selected) {
            fetch(selected.data.href)
                .then(response => response.json())
                .then(data => {
                    const adresseKoordinater = data.adgangsadresse.adgangspunkt.koordinater;
                    const ejerlav = data.adgangsadresse.ejerlav;
                    const matrikelnr = data.adgangsadresse.matrikelnr;
                    const kommune = data.adgangsadresse.kommune.navn;
                    const postnummer = data.adgangsadresse.postnummer.nr;
                    const by = data.adgangsadresse.postnummer.navn;

                    $('#koordinater').val(`${adresseKoordinater[0]},${adresseKoordinater[1]}`);

                    if (matrikelnr) {
                        $('#matrikel').val(matrikelnr);
                    }

                    if (ejerlav) {
                        $('#ejerlavNr').val(ejerlav.kode);
                        $('#ejerlavNavn').val(ejerlav.navn);
                    }

                    $('#by').val(by);
                    $('#postnummer').val(postnummer);
                    $('#kommunenavn').val(kommune);

                    $('#kommuneKode').val(data.adgangsadresse.kommune.kode);
                    $('#ejendomsNr').val(data.adgangsadresse.esrejendomsnr);
                });
        }
    });

    // modal setup
    $('#afPlaceModal')[0].addEventListener('fds.modal.shown', modalShown);
});

function modalShown() {
    if (!modalIsShown) modalIsShown = true;
    else return;

    const feedback = $('#feed-back');
    const page = $('#afPlace');
    let section;
    let afMap;

    $('#afBtnOk, #afBtnYes, #afBtnNo').hide();

    function selectSection(section) {
        if (section) {
            $('input[name=roadNo]').val(section.properties.road.number);
            $('input[name=roadPart]').val(section.properties.road.part);
            $('input[name=fromKm]').val(section.properties.from.km);
            $('input[name=fromM]').val(section.properties.from.m);
            $('input[name=toKm]').val(section.properties.to.km);
            $('input[name=toM]').val(section.properties.to.m);
            $('input[name=geometry]').val(OLUtils.WKT.writeFeature(OLUtils.toFeature(section)));
            page.closest('form').submit();
        } else {
            page.find('input').val('');
            page.closest('form').submit();
        }
    }

    function resetModal() {
        afMap.removeSection();
        feedback.removeClass().html('');
        $('#afBtnOk, #afBtnYes, #afBtnNo').hide();
    }

    $('#afBtnOk').on('click', () => {
        selectSection(null);
        resetModal();
    });

    $('#afBtnYes').on('click', () => {
        selectSection(section);
    });

    $('#afBtnNo').on('click', () => {
        resetModal();
    });

    function onShow() {
        afMap.removeGeometry();

        const coord = $('input[name=addressCoordinate]').val();
        if (coord) {
            const proj = proj4('EPSG:25832', coord.split(',').map(parseFloat));
            afMap.addGeometry(`POINT(${proj[0]} ${proj[1]})`);

            afMap.zoomToContents();
        }

        const view = afMap.map.getView();
        if (view.getZoom() > 11) {
            view.setZoom(11);
        }
    }

    getEnv().then(env => {
        const matrikelLag = new TileLayer({
            title: 'Matrikler',
            source: new TileWMS({
                url: 'https://services.datafordeler.dk/Matrikel/MatrikelGaeldendeOgForeloebigWMS/1.0.0/WMS',
                params: {
                    TRANSPARENT: 'TRUE',
                    LAYERS: 'MatrikelSkel_Gaeldende,Centroide_Gaeldende',
                    username,
                    password
                },
                tileGrid: VDMapTileGrid
            })
        });

        afMap = new VDMap($('#afPlaceMap')[0], {
            activeModes: ['selectSection'],
            bgLayers: [topoSkaermKort()],
            fgLayers: [matrikelLag],
            baseUrl: '/sukort/',
            referencingUrl: env.searchUrl + "/public/referencing",
            modeControl: false,
            layerControl: false,
            addSectionCallback: function (_) {
                const data = afMap.getSections();
                if (data.other.length > 1) {
                    afMap.removeSection(data.other[0]);
                }
                section = data.other[data.other.length - 1].getProperties().sysLine.features[0];

                if (section.properties.authority === 0) {
                    $.getJSON('/get-street-name', {
                        roadNo: section.properties.road.number,
                        roadPart: section.properties.road.part,
                        fromKmt: section.properties.from.kmt,
                        toKmt: section.properties.to.kmt
                    }).then(response => {
                        const text = `Din henvendelse vedrører ${response.streetName || '(vej uden navn)'}. Ønsker du at fortsætte?`;
                        feedback.removeClass().addClass('alert alert-success').html(buildInfoBox('Sted fundet', text));
                        $('#afBtnOk').hide();
                        $('#afBtnYes, #afBtnNo').show();
                    });
                } else {
                    $.getJSON('/get-authority', {code: section.properties.authority}).then(auth => {
                        const text = `Vejdirektoratet kan ikke behandle din sag, da den udpegede vej administreres af ${auth.authority.text}.<br>Du skal ansøge ${auth.authority.text} om tilladelse.`;
                        feedback.removeClass().addClass('alert alert-error').html(buildInfoBox('Fejl', text));
                        $('#afBtnOk').show();
                        $('#afBtnYes, #afBtnNo').hide();
                    });
                }
            }
        });
        afMap.map.getView().padding = [20, 20, 20, 20];


        const geometry = $('input[name=geometry]').val();
        if (geometry) {
            afMap.addSection(OLUtils.toFeature(geometry), true, true);
        }

        onShow();
    });

    $('#afPlaceModal').on('fds.modal.shown', onShow);
}

function buildInfoBox(alertHeading, alertText) {
    let msg = `<div class="alert-body">
                        <h3 class="alert-heading">${alertHeading}</h3>
                        <p class="alert-text">${alertText}</p>
                      </div>`;

    return msg;
}
